export default class PointSizeMap {}